export const FEATURE_FLAG_KEYS = [
  'chargebackDashboardMetrics',
  'receiptsExperience',
  'customServiceFees',
  'exemploFlag',
  'referralProgram',
  'adminDashboardLightLiveView',
  'adminSalesSearchFocus',
  'crmIntegration',
] as const

export type FeatureFlagKey = (typeof FEATURE_FLAG_KEYS)[number]

export type FeatureFlagSource = 'configcat' | 'override' | 'default'

export type FeatureFlagUser = Readonly<{
  identifier: string
  email?: string
  country?: string
  custom?: Readonly<Record<string, string>>
}>
